import React from 'react'

function Tour12() {
  return (
    <div>Tour12</div>
  )
}

export default Tour12